// extracted by mini-css-extract-plugin
export default {"title":"Title_title__EZ83U","titleSecondary":"Title_titleSecondary__eAoyH"};